import { userProgress } from '../stores';
import { progressSvc } from './progress.service';

export class ChapterService {
  constructor(ch) {
    this.chapter = ch;
    this.up = {};

    userProgress.subscribe(up => {
      this.up = up;
    });
  }

  get videoPlayed() {
    return progressSvc.hasVideoPlayed();
  }

  updateStore() {
    progressSvc.setUserProgress(this.up);
  }

  hasVideoPlayed() {
    return this.videoPlayed;
  }

  setVideoPlayed() {
    const chap = this.up.chapters[this.chapter.slug];
    if(!chap) {
      console.error('chapter is undefined', this.chapter.slug, this.up.chapters)
      return;
    }
    chap.videoPlayed = true;
    if (!chap.status || chap.status == 'ready') {
      chap.status = 'started';
    }
    this.updateStore();
  }

  getInitialActiveRule() {
    return 0;
  }

  setRuleRead(index) {
    this._checkUserProgress();
    if(!this.up?.chapters[this.chapter.slug]?.rulesRead) {
      this.up.chapters[this.chapter.slug].rulesRead = {};
    }
    this.up.chapters[this.chapter.slug].rulesRead[index] = true;
    this.updateStore();
  }

  hasAllRulesRead() {
    return progressSvc.hasAllRulesRead();
  }

  _checkUserProgress() {
    if (!this.up?.chapters) {
      this.up.chapters = {};
    }
    if (!this.up?.chapters[this.chapter.slug]) {
      this.up.chapters[this.chapter.slug] = {};
    }
  }
}
